export const MAIN_OUT_ID = "MAIN_OUT";
export const DELAY_UPPER_BOUND = 4;
